module.exports = __webpack_public_path__ + "static/media/smx_logo_white.98edec40.svg";